import React from 'react';
import styled from 'styled-components';
import { SvgIcon } from '../../../Icon';
import * as NoteUI from './NoteUI';
import { queryTypeConfigLookup } from '../../../../utils/queryTypeLookup';
import { IScratchPadNoteFragment } from '../../types';

const DraggedHeader = styled(NoteUI.Header)`
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 0.9;
  cursor: grabbing;
  width: 300px;
  pointer-events: none;
`;

interface DragHeaderProps {
  note: IScratchPadNoteFragment;
}

const DragHeader = ({ note }: DragHeaderProps) => {
  const renderHeaderDetails = () => {
    if (note.content.__typename === 'ReportNote') {
      const queryType = note.content.analysis.queryType;
      const display = queryTypeConfigLookup[queryType].display;

      return (
        <NoteUI.Name>
          <SvgIcon name="drag-drop" width={8} height={8} />
          <SvgIcon name="chart-line" width={16} height={16} />
          {display}
        </NoteUI.Name>
      );
    } else if (note.content.__typename === 'DashboardNote') {
      return (
        <NoteUI.Name>
          <SvgIcon name="drag-drop" width={8} height={8} />
          <SvgIcon name="dashboard" width={16} height={16} />
          Dashboard
        </NoteUI.Name>
      );
    } else if (note.content.__typename === 'CohortNote') {
      return (
        <NoteUI.Name>
          <SvgIcon name="drag-drop" width={8} height={8} />
          <SvgIcon name="users-three" width={16} height={16} />
          Cohort
        </NoteUI.Name>
      );
    } else if (note.content.__typename === 'ImageEmbedNote') {
      return (
        <NoteUI.Name>
          <SvgIcon name="drag-drop" width={8} height={8} />
          <SvgIcon name="image" width={16} height={16} />
          Image
        </NoteUI.Name>
      );
    }
  };

  return <DraggedHeader>{renderHeaderDetails()}</DraggedHeader>;
};

export default DragHeader;
